<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.itineraries', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="font-semibold text-xl">{{ $t('messages.active_itineraries') }}</div>
        <ul role="list" class="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8">
            <li class="relative" v-for="itinerary in itineraries.data" :key="itinerary.id">
                <div
                    class="group aspect-w-10 aspect-h-7 block w-full overflow-hidden rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100"
                >
                    <img
                        :src="itinerary.cover_image_path"
                        alt=""
                        class="pointer-events-none object-cover group-hover:opacity-75"
                    />
                    <InertiaLink :href="itinerary.links.show" class="absolute inset-0 focus:outline-none">
                        <span class="sr-only"> {{ itinerary.name }}</span>
                    </InertiaLink>
                </div>
                <ProgressBarCurrentMax
                    :current="itinerary.current_station"
                    :max="itinerary.stations_count"
                    color="indigo"
                    class="mt-1 w-full"
                />
                <div class="flex justify-between mt-1">
                    <p class="pointer-events-none mt-2 block truncate text-sm font-medium text-gray-900">
                        {{ itinerary.name }}
                    </p>
                    <div class="flex justify-end space-x-1">
                        <InertiaSquareLinkButton action="show" :href="itinerary.links.show" />
                    </div>
                </div>
            </li>
        </ul>

        <InertiaSimplePagination :paginator="itineraries.links" />
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import InertiaSimplePagination from '@/Shared/InertiaSimplePagination.vue';
import ProgressBarCurrentMax from '@/components/Gamification/ProgressBarCurrentMax.vue';

export default {
    components: {
        ProgressBarCurrentMax,
        PanelPage,
        InertiaSimplePagination,
        InertiaSquareLinkButton,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'gamificationSet', 'itineraries', 'filters'],
    data() {
        return {
            form: this.$inertia.form({
                search: this.filters.search,
            }),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
